/**
 * Created by alex.shmaltsuev on 2016-05-04.
 */
export default {
    //reducer const

    SCORE_BOARD_TABS: 'SCORE_BOARD_TABS',
    SCORE_BOARD_TABS_ORDER: 'SCORE_BOARD_TABS_ORDER',
    SCORE_BOARD_TABS_NO_DATA_TEXT: 'SCORE_BOARD_TABS_NO_DATA_TEXT',
    SERVICE_CATALOG_ACTIVE_REQUESTS: 'SERVICE_CATALOG_ACTIVE_REQUESTS',
    SERVICE_CATALOG_ACTIVE_REQUESTS_WIDGET: 'SERVICE_CATALOG_ACTIVE_REQUESTS_WIDGET',
    SERVICE_CATALOG_CLOSED_REQUESTS: 'SERVICE_CATALOG_CLOSED_REQUESTS',
    SERVICE_CATALOG_CLOSED_REQUESTS_WIDGET: 'SERVICE_CATALOG_CLOSED_REQUESTS_WIDGET',
    SERVICE_CATALOG_SUPERVISED_REQUESTS: 'SERVICE_CATALOG_SUPERVISED_REQUESTS',
    SERVICE_CATALOG_SUPERVISED_REQUESTS_WIDGET: 'SERVICE_CATALOG_SUPERVISED_REQUESTS_WIDGET',
    SERVICE_CATALOG_PENDING_REQUESTS: 'SERVICE_CATALOG_PENDING_REQUESTS',
    SERVICE_CATALOG_PENDING_REQUESTS_WIDGET: 'SERVICE_CATALOG_PENDING_REQUESTS_WIDGET',
    SERVICE_CATALOG_ACTIVE_REQUESTS_COUNT: 'SERVICE_CATALOG_ACTIVE_REQUESTS_COUNT',
    SERVICE_CATALOG_CLOSED_REQUESTS_COUNT: 'SERVICE_CATALOG_CLOSED_REQUESTS_COUNT',
    SERVICE_CATALOG_SUPERVISED_REQUESTS_COUNT: 'SERVICE_CATALOG_SUPERVISED_REQUESTS_COUNT',
    SERVICE_CATALOG_PENDING_REQUESTS_COUNT: 'SERVICE_CATALOG_PENDING_REQUESTS_COUNT',
    SERVICE_CATALOG_PENDING_REQUEST_PUT: 'SERVICE_CATALOG_PENDING_REQUEST_PUT',
    SCORE_BOARD_ACTIVE_TAB: 'SCORE_BOARD_ACTIVE_TAB',
    SERVICE_CATALOG_PENDING_COMPLETE: 'complete',
    SERVICE_CATALOG_PENDING_APPROVE: 'approve',
    SERVICE_CATALOG_PENDING_REJECT: 'reject',
    SERVICE_CATALOG_PENDING_REOPEN: 'reopen',
    SERVICE_CATALOG_IS_SHOW_ALL: 'isShowAll',
    SERVICE_CATALOG_RESET_COMP: 'SERVICE_CATALOG_RESET_COMP',

    //component const
    RECORDS_DISPLAY_IN_LIST:'recordsDisplayedInLists',
    MY_REQUEST_TAB: 'activeSrs',
    RECENTLY_CLOSED_TAB: 'closedSrs',
    SUPERVISED_REQUESTS_TAB: 'supervisedSrs',
    PENDING_MY_APPROVAL_TAB: 'workflowActions',
    TITLE: 'title',
    SR_TITLE: 'sr.title',
    UPDATE_TIME: 'update_time',
    STATUS: 'status',
    PRIORITY: 'priority',
    INSERT_TIME: 'insert_time',
    URGENCY: 'urgency',
    SR_TYPE: 'sr_type',
    TABS: 'tabs',
    TABS_ORDER: 'tabsOrder',
    TAB_CAPTION_KEY: 'captionRbKey',
    TAB_NO_DATA_CAPTION_KEY: 'noDataRbKey',

    ENABLED_TIME: 'enabled_time',
    PENDING_STATUS: 'status',
    PENDING_TITLE: 'sr.title',
    PENDING_SR_ID: 'sr_id',
    PENDING_ENABLED_TIME: 'enabled_time',
    PENDING_MODIFY_TIME: 'modify_time',
    PENDING_DUE_DATE: 'due_date',
    PENDING_TAB_NAME: 'tab_name',
    PENDING_ASSIGNED_TO: 'assigned_to',

    ACTIVE_REQUESTS_ARRAY: 'activeRequestsArray',
    ACTIVE_REQUESTS_ARRAY_WIDGET: 'activeRequestsArrayWidget',
    ACTIVE_REQUESTS_COUNT: 'activeRequestsCount',
    PENDING_REQUESTS_ARRAY: 'pendingRequestsArray',
    PENDING_REQUESTS_ARRAY_WIDGET: 'pendingRequestsArrayWidget',
    PENDING_REQUESTS_COUNT: 'pendingRequestsCount',
    CLOSED_REQUESTS_ARRAY: 'closedRequestsArray',
    CLOSED_REQUESTS_ARRAY_WIDGET: 'closedRequestsArrayWidget',
    CLOSED_REQUESTS_COUNT: 'closedRequestsCount',
    SUPERVISED_REQUESTS_ARRAY: 'supervisedRequestsArray',
    SUPERVISED_REQUESTS_ARRAY_WIDGET: 'supervisedRequestsArrayWidget',
    SUPERVISED_REQUESTS_COUNT: 'supervisedRequestsCount',
    ACTIVE_TAB_NAME: 'activeTabName',
    ACTIVE_REQUESTS_ID: 'ACTIVE_REQUESTS_ID',
    SUPERVISED_REQUESTS_ID: 'SUPERVISED_REQUESTS_ID',
    CLOSED_REQUESTS_ID: 'CLOSED_REQUESTS_ID',
    PENDING_REQUESTS_ID: 'PENDING_REQUESTS_ID',
    REQUEST_USER: 'request_user',
    SERVICE_REQ_WIDGET_LIMIT: 4,
    FILTER:'filter',
    ELEMENT_PER_PAGINATION: 50,
    BADGES_CUSTOM_FIELDS: 'badges',
    COLUMNS_CUSTOM_FIELDS: 'columns',
    STATIC_FILTER_ID: 'staticFilterId',
    GET_LIST_OF_FILTERS:'GET_LIST_OF_FILTERS',
    UPDATE_SHOW_ALL_FILTER:'UPDATE_SHOW_ALL_FILTER',
    SHOW_ALL_FILTER:'showAllFilter',
    CATEGORY_TYPE: {
        FIRST: 'problem_type',
        SECOND: 'problem_sub_type',
        THIRD: 'third_level_category'
    }
}



// WEBPACK FOOTER //
// ./constants/scoreBoard.js